import {
  Component,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { ConfigApi } from './config-api';
import { Globals } from './shared/global';
import { ApiCallingService } from './shared/services/api-calling.service';
import { ToastrService } from 'ngx-toastr';
import { sharedBroadcast } from './pages/footer/footer.component';
import { Modal } from 'bootstrap';
import { environment } from 'src/environments/environment';

//auto focus directive used in select2 dropdown
@Directive({
  selector: '[appAutofocus]',
})
export class AutofocusDirective implements OnInit {
  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.el.nativeElement.focus();
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  title = 'lnt-itc';

  @ViewChild('statusModal') statusModal!: ElementRef;
  @ViewChild('closedModal') closedModal: any;
  showPopup: boolean = false;

  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHandler(event: Event) {
  //   localStorage.clear();
  // }

  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private broadcastService: MsalBroadcastService,
    private authService: MsalService,
    public globals: Globals,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService
  ) { }


  ngOnInit(): void {
    console.log(environment.FILE_TYPE);

    this.authService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result?.account) {
          this.authService.instance.setActiveAccount(result.account);
        }
        
      const activeAccount = this.authService.instance.getActiveAccount();

      if (!activeAccount) {
        const accounts = this.authService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.authService.instance.setActiveAccount(accounts[0]);
        }
      }
      const account = this.authService.instance.getActiveAccount();
      if (account) {
        localStorage.setItem('isUserssoresponsereceived', 'true');
        localStorage.setItem('userssoresponse', JSON.stringify(account));
       // localStorage.setItem('userssoresponse', JSON.stringify(data));
        localStorage.setItem(
          'usersessionexpire',
          JSON.stringify(account.idTokenClaims?.exp)
        );
        
        // var usersessionexpire: any =
        // localStorage.getItem('usersessionexpire');
       this.startSessionTimer(account.idTokenClaims?.exp);
      }
      this.setLoginDisplay();
      
      },
      error: (error) => console.error(error),
  
    });

    // this.broadcastService.inProgress$
    //   .pipe(
    //     filter(
    //       (status: InteractionStatus) => status === InteractionStatus.None
    //     ),
    //     takeUntil(this._destroying$)
    //   )
    //   .subscribe(() => {
    //     if (this.authService.instance.getAllAccounts().length > 0) {
    //       var data = this.authService.instance.getAllAccounts();

    //       localStorage.setItem('isUserssoresponsereceived', 'true');
    //       localStorage.setItem('userssoresponse', JSON.stringify(data));
    //       localStorage.setItem(
    //         'usersessionexpire',
    //         JSON.stringify(data[0].idTokenClaims?.exp)
    //       );

    //       var usersessionexpire: any =
    //         localStorage.getItem('usersessionexpire');

    //       setInterval(() => {
    //         const currentdatetime = new Date().getTime() / 1000;
    //         if (usersessionexpire && currentdatetime >= usersessionexpire) {
    //           this.logout();
    //         }
    //         // if (usersessionexpire - currentdatetime >= 60) {
    //         //   this.openModal();
    //         // }
    //       }, 60 * 100); // 1 second
    //     }
    //     this.setLoginDisplay();
    //   });
  }

  private startSessionTimer(expiry: number | undefined): void {
    if (!expiry) return;
  
    setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000);
  
      if (currentTime >= expiry) {
        this.logout();
      }
    }, 1000);
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  //scroll-disable logic
  ngAfterViewInit() {

    document.addEventListener(
      'wheel',
      function (event: WheelEvent) {

        const target = event.target as HTMLInputElement;

        if (target && target.tagName === 'INPUT' && target.type === 'number') {
          event.preventDefault();
        }

      },
      { passive: false }
    );

  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  logout() {
    var url = ConfigApi.URLS.LOGOUT_URL;
    const payload = {
      userId: this.globals.getUser().UserId,
      description: 'logout due to sso session timeout',
    };
    this.apiCallingService
      .callAuthPostAPI(payload, 'POST', url)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(JSON.parse(res))) {
          var LoginWith = localStorage.getItem('LoginWith');
          localStorage.clear();
          // this.router.navigateByUrl("login");
          this.toastr.success(
            'You have been forcefully logged out. Please log in again.'
          );
          sharedBroadcast.postMessage('logout');

          // if (LoginWith == 'SSO') {
          //   this.authService.logoutRedirect({
          //     postLogoutRedirectUri: ConfigApi.HOST_BASE_URL
          //   });
          // } else {
          setTimeout(() => {
            window.location.reload();
          }, 500);
          // }
        }
      });
  }

  openModal() {
    this.showPopup = true;
    const modal = new Modal(this.statusModal.nativeElement);
    modal.show();
  }
}
